/* AUTAVEX: one add-to-cart call = one bundle in cart (site-wide) + виправлення тексту «Зацініть» -> «Оплатити» */
(function(){
if(window.__avBundlePatched)return;
window.__avBundlePatched=1;
function newId(){return 'AV'+Date.now().toString(36)+Math.floor(Math.random()*46656).toString(36)}
function tag(body){
  var d;
  try{d=JSON.parse(body)}catch(e){return null}
  if(!d||!d.items||!d.items.length||d.items.length<2)return null;
  for(var i=0;i<d.items.length;i++){
    var pp=d.items[i].properties;
    if(pp&&pp._bundle)return null;
  }
  var bid=newId();
  for(var j=0;j<d.items.length;j++){
    var it=d.items[j];
    if(!it.properties||typeof it.properties!=='object')it.properties={};
    it.properties._bundle=bid;
    if(j===0)it.properties._main='1';
  }
  try{return JSON.stringify(d)}catch(e2){return null}
}
function isAdd(u){return typeof u==='string'&&u.indexOf('/cart/add')>-1}
var of=window.fetch;
if(typeof of==='function'){
  window.fetch=function(u,o){
    try{
      var url=isAdd(u)?u:((u&&typeof u.url==='string')?u.url:'');
      if(url.indexOf('/cart/add')>-1&&o&&typeof o.body==='string'){
        var nb=tag(o.body);
        if(nb)o.body=nb;
      }
    }catch(e){}
    return of.apply(this,arguments);
  };
}
var xs=window.XMLHttpRequest&&window.XMLHttpRequest.prototype;
if(xs&&xs.open&&xs.send){
  var oo=xs.open,os=xs.send;
  xs.open=function(m,u){try{this.__avUrl=u}catch(e){}return oo.apply(this,arguments)};
  xs.send=function(b){
    try{
      if(typeof this.__avUrl==='string'&&this.__avUrl.indexOf('/cart/add')>-1&&typeof b==='string'){
        var nb=tag(b);
        if(nb)return os.call(this,nb);
      }
    }catch(e){}
    return os.apply(this,arguments);
  };
}

/* —— виправлення кнопки checkout: Shopify-переклад «Зацініть» -> «Оплатити» —— */
function fixCheckoutText(root){
  var scope=root&&root.querySelectorAll?root:document;
  var els=scope.querySelectorAll('button, a, span, div');
  for(var i=0;i<els.length;i++){
    var el=els[i];
    if(el.children&&el.children.length)continue;
    var t=(el.textContent||'').trim();
    if(t==='\u0417\u0430\u0446\u0456\u043d\u0456\u0442\u044c')el.textContent='\u041e\u043f\u043b\u0430\u0442\u0438\u0442\u0438';
  }
}
function bootFix(){
  try{fixCheckoutText(document)}catch(e){}
  if(window.MutationObserver){
    var mo=new MutationObserver(function(muts){
      for(var i=0;i<muts.length;i++){
        var added=muts[i].addedNodes;
        for(var j=0;j<added.length;j++){
          var n=added[j];
          if(n.nodeType===1)try{fixCheckoutText(n)}catch(e){}
        }
      }
    });
    mo.observe(document.documentElement,{childList:true,subtree:true});
  }
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',bootFix)}else{bootFix()}
})();
